export default __webpack_public_path__ + "static/media/IMG-20250105-WA0025.4bea839f.jpg";